// Per-browser ops-page preferences (SCRUM-401). They describe the screen the
// page is shown on — a venue laptop with people looking over the operator's
// shoulder — not the logged-in user, so they live in localStorage like the
// sidebar's collapsed state, never on the API.
export const PREF_HIDE_SALES = 'ops.hideSales'; // '1' hides the Purchased card, revenue text and cha-ching
export const PREF_PIPELINE_OPEN = 'ops.pipelineOpen'; // '1' expands the detailed pipeline strip under the one-pill summary

export function readPref(key, fallback) {
  try {
    const v = localStorage.getItem(key);
    return v == null ? fallback : v === '1';
  } catch {
    return fallback;
  }
}

export function writePref(key, on) {
  try { localStorage.setItem(key, on ? '1' : '0'); } catch { /* ignore */ }
}
